module.exports = __webpack_public_path__ + "pic/10.24851e0d.png";